import React, { useState, useEffect, useRef } from 'react'
import $ from 'jquery';
import { getAssetAUM } from '../../../actions/assetDetailsActions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { AssetDropDown } from "../../../UiComponents/AssetDropDown";
import { getAssestListddlAction } from "../../../actions/assetsddlAction";
import { GetAssetAUMOptAction } from "../../../actions/assetAUMAction";
import { getAsset } from "../../../actions/assetAction";
import { TopBar } from "../../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../../config/routeConfig";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { useNavigate } from "react-router";
import download from '../../Images/download.svg';
import { exportToExcel } from '../../../utils/excelExporter';
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import "./AUMList.css";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { InsertorUpdateAUM, getAssetAUMOpt } from "../../../../config/apiConfig";
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";
import { DeleteAUM } from "../../../../config/apiConfig";
import { sbaAxios } from '../../../utils/sbaAxios';
export const AUMList = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useNavigate();
  const gridApi = useRef(null);
  const currentDate = new Date();
  const previousMonth = currentDate.getMonth() - 1;
  const previousMonthEndDate = new Date(
    currentDate.getFullYear(),
    previousMonth + 1,
    0
  );
  const [showDrawer, setshowDrawer] = useState(false);
  const [aumData, setaumData] = useState([]);
  const [valuationDate, setvaluationDate] = useState();
  const [assetAUMValue, setassetAUMValue] = useState();
  const [assetValuationId, setassetValuationId] = useState();
  const [strategyAUMValue, setstrategyAUMValue] = useState();
  const [startegyValuationId, setstrategyValuationId] = useState();
  const [entityId, setentityId] = useState();
  const [firmAUMValue, setfirmAUMValue] = useState();
  const [firmValuationId, setfirmValuationId] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedassetValuationId, setselectedassetValuationId] = useState();
  const [selectedstartegyValuationId, setselectedstrategyValuationId] = useState();
  const [selectedfirmValuationId, setselectedfirmValuationId] = useState();
  const [mode, setmode] = useState();
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  const isEditable = Gstate.authorizationData.isEditable;

  const AssetListDDL = Gstate.assetDDL.assetList || [];
  const [radioValue, setRadioValue] = useState(4);
  const [aumListData, setAUMListData] = useState({});


  const [AUMLoading, setAUMLoading] = useState(false);

  // Gstate.AssetAUMOpt.isLoading;

  const gridData = aumListData?.AumData?.map(item => {
    const formattedRow = {
      ...item,
      ValuationDate: getMonthFormatted(item.ValuationDate),
      AssetValue: FormatCurrencyGrid(item.AssetValue),
      StrategyValue: FormatCurrencyGrid(item.StrategyValue),
      FirmValue: FormatCurrencyGrid(item.FirmValue),
      AsofDate: getDateFormatted(item.ValuationDate),
    }
    return formattedRow;
  }) || [];
  const AssetAUM = aumListData?.AssetAUM || "";
  const StrategyAUM = aumListData?.StrategyAUM || "";
  const FirmAUM = aumListData?.FirmAUM || "";
  const SummaryAUM = aumListData ? aumListData[0] : "";

  const currentAsset = Gstate.asset.asset || {};
  useEffect(() => {
    document.title = `Asset AUM`;
  }, []);
  const GetAssetAUMOptData = (AssetId, opt) => {
    setAUMLoading(true);
    sbaAxios({
      url: `${getAssetAUMOpt}${AssetId},${opt}`,
      method: 'get',
    })
      .then((repos) => {
        setAUMListData(repos);
        setAUMLoading(false);
      })
      .catch((error) => {
        setAUMListData({});
        setAUMLoading(false);
      });
  }
  useEffect(() => {
    //   dispatch(getAssetAUM(params.AssetId, previousMonthEndDate));
    GetAssetAUMOptData(params.AssetId, radioValue)
    // dispatch(GetAssetAUMOptAction(params.AssetId, radioValue));
    dispatch(getAssestListddlAction());
    dispatch(getAsset(params.AssetId));
  }, []);
  const AssetDDChanged = (e) => {
    e.value && history(`${UrlPath.AUMList}${e.value.AssetId}`);
    e.value && dispatch(getAsset(e.value.AssetId));
    // dispatch(getAssetAUM(e.value.AssetId, previousMonthEndDate));
    // dispatch(GetAssetAUMOptAction(e.value.AssetId, radioValue));
    GetAssetAUMOptData(e.value.AssetId, radioValue);
  };
  const OptionBasedAUM = (opt) => {
    setRadioValue(opt);
    GetAssetAUMOptData(params.AssetId, opt);

    // dispatch(GetAssetAUMOptAction(params.AssetId,opt));
  };
  const Level = [
    {
      BreadCrumb: "Asset >",
      Routes: `${UrlPath.Asset}`,
    },
    { BreadCrumb: `${currentAsset.AssetName} >`, Routes: `${UrlPath.AssetDetails}${params.AssetId}` },
    { BreadCrumb: 'AUM', Routes: `${UrlPath.AUMList}${params.AssetId}` },
  ];
  const valuationDateChange = (selected) => {
    setvaluationDate(new Date(moment(selected).format('MM/DD/YYYY')));
  };

  const assetAUMValuechange = (event) => {
    setassetAUMValue(event.target.value);
  }
  const strategyAUMValuechange = (event) => {
    setstrategyAUMValue(event.target.value);
  }
  const firmAUMValuechange = (event) => {
    setfirmAUMValue(event.target.value);
  }
  const AUMNewPoup = () => {

    setvaluationDate(moment(previousMonthEndDate).format("MM-DD-YYYY"));
    setassetAUMValue('');
    setstrategyAUMValue('');
    setfirmAUMValue('');
    setentityId(params.AssetId);
    setmode("Add");
    setshowDrawer(true);
  };
  const ActionsRenderer = (props) => {
    const NavigatetoEdit = () => {

      if (isEditable !== false) {
        setassetValuationId(props.data.AssetValuationId);
        setvaluationDate(props.data.AsofDate);
        setassetAUMValue(props.data.AssetValue === 0 ? '' : props.data.AssetValue);
        setstrategyValuationId(props.data.StrategyValuationId)
        setstrategyAUMValue(props.data.StrategyValue === 0 ? '' : props.data.StrategyValue);
        setfirmValuationId(props.data.FirmValuationId);
        setfirmAUMValue(props.data.FirmValue === 0 ? '' : props.data.FirmValue);
        setentityId(props.data.EntityId);
        setmode("Edit");
        setshowDrawer(true);
      }

    }
    const DeleteClick = () => {
      if (isEditable !== false) {
        setShowDeleteModal(true);
        setselectedassetValuationId(props.data.AssetValuationId);
        setselectedstrategyValuationId(props.data.StrategyValuationId);
        setselectedfirmValuationId(props.data.FirmValuationId);
      }
    };
    return (

      <div className="actions-cell">
        <i className="fas fa-edit" style={{ color: isEditable === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={NavigatetoEdit}></i>
        <i className="fa fa-trash" style={{ color: isEditable === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={DeleteClick}  ></i>
      </div>



    )


  };
  const cancelAUMpoup = () => {
    setshowDrawer(false);
  }

  const ColumnDefs = [
    {
      field: "ValuationDate",
      headerName: "Month",
      // valueFormatter: getMonthFormatted,

    },
    {
      field: "AsofDate",
      headerName: "As of Date",
      // valueFormatter: getDateFormatted,

    },
    {
      field: "AssetValue",
      headerName: "Asset AUM,MM",
      // valueFormatter: FormatCurrencyGrid,
      cellStyle: { textAlign: "right" },
      headerClass: 'header-align-right',
      // cellRenderer: params => {

      //   if (params.data.AssetValue === 0) {
      //     return ``;
      //   }
      //   else {
      //     return FormatCurrency(params.data.AssetValue);
      //   }

      // },
      minWidth: 100, maxWidth: 180,
      // sort: 'asc'
    },
    {
      field: "StrategyValue",
      headerName: "Strategy AUM,MM",
      // valueFormatter: FormatCurrencyGrid,
      cellStyle: { textAlign: "right" },
      headerClass: 'header-align-right',
      // cellRenderer: params => {
      //   if (params.data.StrategyValue === 0) {
      //     return ``;
      //   }
      //   else {
      //     return FormatCurrency(params.data.StrategyValue);
      //   }

      // },
      minWidth: 100, maxWidth: 180
    },
    {
      field: "FirmValue",
      headerName: "Firm AUM,MM",
      // valueFormatter: FormatCurrencyGrid,
      cellStyle: { textAlign: "right" },

      headerClass: 'header-align-right',
      // cellRenderer: params => {
      //   if (params.data.FirmValue === 0) {
      //     return ``;
      //   }
      //   else {
      //     return FormatCurrency(params.data.FirmValue);
      //   }

      // },
      minWidth: 100, maxWidth: 150
    },
    {
      field: "Action",
      headerName: "Action",
      cellRenderer: ActionsRenderer,
      filter: false,

    }
  ];
  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable: true
  };
  const InsertorUpdateAUMDetails = (event) => {
    let saveSuccess = true;
    let errorMsg = [];
    event.preventDefault();
    // Prepare the data to be sent in the POST request
    const data = {
      "AssetId": params.AssetId,
      "ValuationDate": valuationDate,
      "AssetValuationId": assetValuationId,
      "AssetValue": assetAUMValue ? String(assetAUMValue).replace(/[^0-9.]/g, '') : 0,
      "StrategyValuationId": startegyValuationId,
      "StrategyValue": strategyAUMValue ? String(strategyAUMValue).replace(/[^0-9.]/g, '') : 0,
      "FirmValuationId": firmValuationId,
      "FirmValue": firmAUMValue ? String(firmAUMValue).replace(/[^0-9.]/g, '') : 0,
      "ModifiedBy": 38,
    };
    if ((!assetAUMValue) && (!strategyAUMValue) && (!firmAUMValue)) {
      saveSuccess = false;
      errorMsg.push("Please Enter Atleast one Value");
    }
    if (saveSuccess) {
      sbaAxios({
        url: `${InsertorUpdateAUM}`,
        method: 'post',
        data: data,
      })
        .then((response) => {
          toast.success('AUM Values Posted Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setshowDrawer(false);
          GetAssetAUMOptData(params.AssetId, radioValue);
          setassetValuationId(0);
          setvaluationDate(null);
          setassetAUMValue(0);
          setstrategyValuationId(0)
          setstrategyAUMValue(0);
          setfirmValuationId(0);
          setfirmAUMValue(0);
          setentityId(0);
          // dispatch(GetAssetAUMOptAction(params.AssetId,radioValue));
        })

        .catch((error) => {
          console.error(error);
        });
    }
    else {
      let ErrorString = "";
      errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
      console.log(errorMsg);
      toast.warning(ErrorString, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  };


  //   const UpdateAUMDetails = (event) => {
  //   let saveSuccess = true;
  //     let errorMsg = [];

  //   event.preventDefault();
  //   // Prepare the data to be sent in the POST request
  //   const data = {
  //     "EntityId": entityId,
  //     "EntityTypeId": 1,
  //     "ValuationDate":valuationDate ,
  //     "AssetValuationId": assetValuationId,
  //     "AssetValue": assetAUMValue,
  //     "StrategyValuationId": startegyValuationId,
  //     "StrategyValue": strategyAUMValue,
  //     "FirmValuationId" : firmValuationId,
  //     "FirmValue" : firmAUMValue,
  //     "ModifiedBy": 38,
  //       };
  //       if ((!assetAUMValue) && (!strategyAUMValue) && (!firmAUMValue)){
  //         saveSuccess = false;
  //         errorMsg.push("Please Enter Atleast one Value");
  //       }
  //       if (saveSuccess) {
  //       fetch(UpdateAUM, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(data),
  //       })
  //         .then((response) => response.json())
  //         .then((responseData) => {
  //           toast.success('AUM Values Posted Successfully', {
  //             position: "top-right",
  //             autoClose: 5000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //             progress: undefined,
  //             theme: "light",
  //           })
  // setshowDrawer(false);
  // dispatch(GetAssetAUMOptAction(params.AssetId,radioValue));
  //         })

  //       .catch((error) => {
  //         console.error(error);
  //       });
  //     }
  //     else {
  //       let ErrorString = "";
  //       errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
  //       console.log(errorMsg);
  //       toast.warning(ErrorString, {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: false,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "light",
  //       })
  //     }
  // };
  const DeleteAumdetails = () => {
    setShowDeleteModal(false);
    sbaAxios({
      url: `${DeleteAUM}AssetValuationId=${selectedassetValuationId}&StrategyValuationId=${selectedstartegyValuationId}&FirmValuationId=${selectedfirmValuationId}`,
      method: 'Post',
    }).then(response => {
      setTimeout(() => {
        toast.success('AUM  Deleted Successfully', {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
        GetAssetAUMOptData(params.AssetId, radioValue);
        // dispatch(GetAssetAUMOptAction(params.AssetId, radioValue));
      }, 100);
    })
      .catch(error => {
        console.error('Error deleting data:', error);
      });
  }
  const closeModal = () => {
    setShowDeleteModal(false);
  }
  return (
    <div className="AUMdiv">
       <>
        <TopBar label={"Asset AUM"} />
        <BreadCrumbs Levels={Level} />
        <div class="p-4" className="mainContentData">
          {AUMLoading ? (
            <LoadingScreen />
          ) : (<>
            <div className='p-4'>

              <div className="col-lg-12 d-flex gap-3  p-0 align-items-center">
                <h2 class="fw-medium fs-6 m-0">{currentAsset?.AssetName}</h2>
                <div
                  className="d-flex gap-1  justify-content-lg-end p-0 align-items-center"
                  style={{ marginLeft: "auto" }}
                >
                  <div style={{ width: "300px" }}>
                    <AssetDropDown
                      value={currentAsset}
                      onChange={AssetDDChanged}
                      data={AssetListDDL}
                    />
                  </div>
                  <div className="d-flex gap-2">
                    <button className="p-sm-btn mx-1" disabled={!isEditable} onClick={AUMNewPoup} >
                      <i className="fa-solid fa-plus" /> Add
                    </button>
                    <button
                      type="button"
                      className="p-sm-btn mx-1"
                      onClick={() => {

                        exportToExcel(gridApi, "Asset AUM List.xlsx");
                      }}
                    >
                      <img src={download} alt="" />
                      Export
                    </button>
                  </div>
                </div>
              </div>
              <div><br></br></div>
            </div>
            <div className='d-flex p-0 m-0' >
              <div className='p-1 col-md-4' >
              <div class=" detail p-3">
                <div class="row p-1 border-bottom  m-0">
                  <div class="col-6 left">
                    <span class="fw-medium">Asset, MM</span>
                  </div>
                </div>
                <div class="row p-1 m-0">
                  <div class="col-6 left">
                    <span>For Selected Range</span>
                  </div>
                  <div class="col-6 text-sm-end">
                    <span>{AssetAUM ? FormatCurrency(AssetAUM) : "N/A"}</span>
                  </div>
                </div>
              </div>
              </div>
              <div className='p-1 col-md-4' >
              <div class="detail p-3">
                <div class="row p-1 border-bottom  m-0">
                  <div class="col-6 left">
                    <span class="fw-medium">Strategy, MM</span>
                  </div>
                </div>
                <div class="row p-1 m-0">
                  <div class="col-6 left">
                    <span>For Selected Range</span>
                  </div>
                  <div class="col-6 text-sm-end">
                    {StrategyAUM ? FormatCurrency(StrategyAUM) : "N/A"}
                  </div>
                </div>
              </div>
              </div>
              <div className='p-1 col-md-4' >
              <div class="detail p-3">
                <div class="row p-1 border-bottom m-0">
                  <div class="col-6 left">
                    <span class="fw-medium">Firm, MM </span>
                  </div>
                </div>
                <div class="row p-1 m-0">
                  <div class="col-6 left">
                    <span>For Selected Range</span>
                  </div>
                  <div class="col-6 text-sm-end">
                    <span> {FirmAUM ? FormatCurrency(FirmAUM) : "N/A"}</span>
                  </div>
                </div>
              </div>
              </div>
            </div>
            <br></br>
            <div
              className="AUMYearRG d-flex gap"
            >
              <span className="radioSelectorGroup">
                <div>
                  <span
                    className={
                      radioValue === 0
                        ? "selected YearRadioSpan"
                        : "YearRadioSpan"
                    }
                    onClick={() => {
                      OptionBasedAUM(0);
                    }}
                  >
                    1Y
                  </span>
                </div>
                <div>
                  <span
                    className={
                      radioValue === 1
                        ? "selected YearRadioSpan"
                        : "YearRadioSpan"
                    }
                    onClick={() => {
                      OptionBasedAUM(1);
                    }}
                  >
                    3Y
                  </span>
                </div>
                <div>
                  <span
                    className={
                      radioValue === 2
                        ? "selected YearRadioSpan"
                        : "YearRadioSpan"
                    }
                    onClick={() => {
                      OptionBasedAUM(2);
                    }}
                  >
                    5Y
                  </span>
                </div>
                <div>
                  <span
                    className={
                      radioValue === 3
                        ? "selected YearRadioSpan"
                        : "YearRadioSpan"
                    }
                    onClick={() => OptionBasedAUM(3)}
                  >
                    10Y
                  </span>
                </div>
                <div>
                  <span
                    className={
                      radioValue === 4
                        ? "selected YearRadioSpan"
                        : "YearRadioSpan"
                    }
                    onClick={() => OptionBasedAUM(4)}
                  >
                    ITD
                  </span>
                </div>
                {/* <div>
       
            <span
              className={
                radioValue === 5 
                  ? "selected YearRadioSpan"
                  : "YearRadioSpan"
              }
              onClick={()=>OptionBasedAUM(5)}
            >
              Custom
            </span>
        
        </div> */}
              </span>
            </div>


            <div>
              <div
                className="d-flex gap-4 justify-content-end "
                style={{ marginTop: "1%" }}
              ></div>
            </div>

            <div
              className="ag-theme-alpine"
              style={{ width: "100%", height: "700px" }}
            >
              <AgGridReact
                columnDefs={ColumnDefs}
                rowData={gridData}
                defaultColDef={defaultColDef}
                pagination={true}
                paginationPageSize={20}
                onGridReady={(params) => {

                  gridApi.current = params.api;
                }}
              ></AgGridReact>
            </div>
            <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Post AUM (values in millions)'}>
            <div>

              <label className="header-container m-1"><b>Valuation Date</b></label>
              <div>
                <SBDatePicker popupSettings={{ className: 'modalDD' }} className="w-75" id="txtValuationDate" value={moment(valuationDate)} onChange={valuationDateChange}>
                </SBDatePicker>

              </div>
              <br></br>
              <label className="header-container m-1"><b>Asset AUM </b></label>
              <div>
                <NumericTextBox className="w-75"
                  defaultValue={assetAUMValue}
                  format="n2" onChange={assetAUMValuechange}
                />
              </div>
              <br></br>
              <label className="header-container m-1"><b>Strategy AUM</b></label>
              <div>
                <NumericTextBox className="w-75"
                  defaultValue={strategyAUMValue}
                  format="n2" onChange={strategyAUMValuechange}
                />
              </div>
              <br></br>
              <label className="header-container m-1"><b>Firm AUM</b></label>
              <div>
                <NumericTextBox className="w-75"
                  defaultValue={firmAUMValue}
                  format="n2"
                  onChange={firmAUMValuechange}
                />
              </div>
              <div className="mt-4">
                <button className="s-sm-btn mx-1" onClick={cancelAUMpoup}>
                  Cancel
                </button>
                {mode === "Edit" && (
                  <button className="p-sm-btn mx-1" onClick={InsertorUpdateAUMDetails} disabled={!isEditable}>
                    Update
                  </button>
                )}
                {mode === "Add" && (
                  <button className="p-sm-btn mx-1" onClick={InsertorUpdateAUMDetails} disabled={!isEditable}>
                    Save
                  </button>
                )}
              </div>

            </div>
          </SBADrawer>

          <Modal show={showDeleteModal}  >
            <Modal.Header closeButton onClick={closeModal}>
              <Modal.Title>Do you want to delete the selected AUM?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>The selected AUM will be deleted permanently. Are you sure?</p>
            </Modal.Body>
            <Modal.Footer>
              <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
              <button className='p-sm-btn mx-1' onClick={DeleteAumdetails} disabled={!isEditable} >
                Yes
              </button>
            </Modal.Footer>
          </Modal>


          <ToastContainer></ToastContainer>
          </>)}






       
        </div>
        </>
        </div>
        );
}
const getMonthFormatted = (params) => {
  const formattedDate = moment(params).format("MMM-YYYY");
  return formattedDate;
};
const getDateFormatted = (params) => {
  return moment(params).format("MM-DD-YYYY");
};
const FormatCurrencyGrid = (val) => {
  if (val == null || isNaN(val)) {
      return ""; 
  }
        if (val == 0) {
      return ""; 
  }
        return (
        "$ " +
        val.toLocaleString("en-US", {
          minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) +
        " MM"
        );
};

const FormatCurrency = (val) => {
  var num = val;
        if (num != undefined) {
    return (
        "$ " +
        num.toLocaleString("en-US", {
          minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) +
        " " +
        "MM"
        );
  } else return num;
};